export default {
  schedule: {
    date_and_time: 'Date et heure*',
    number_of_guests: 'Nombre de convives*',
    location: 'Lieu :',
  },
  personal_information: {
    title: 'Titre',
    first_name: 'Prénom',
    enter_first_name: 'Saisir le prénom',
    last_name: 'Nom*',
    enter_last_name: 'Saisir le nom',
    email: 'E-mail',
    enter_email: "Saisir l'e-mail",
    phone: 'Téléphone',
    annotation: 'Annotation',
    enter_annotation: "Saisir l'annotation",
  },
  gender: {
    without_title: 'Sans titre',
    male: 'M.',
    female: 'Mme',
  },
  buttons: {
    save: 'Enregistrer',
  },
  error_messages: {
    invalid_email: 'Veuillez saisir une adresse e-mail valide, sans espaces ni trémas avant le @.',
    invalid_phone_number: 'Numéro de téléphone invalide. Veuillez vérifier vos informations et réessayer.',
    failed_reservation: "Échec de l'envoi de votre réservation. Veuillez vérifier vos informations et réessayer.",
    invalid_reservation_day: "Nous n'acceptons pas de réservations ce jour-là.",
    no_tables_available: "Désolé, nous n'avons plus de tables disponibles.",
    please_enter_guests: 'Veuillez indiquer le nombre de convives.',
    please_select_time: 'Veuillez sélectionner une heure.',
    please_select_last_name: 'Veuillez saisir le nom de famille',
  },
  success_messages: {
    reservation_saved: 'Réservation enregistrée avec succès',
  },
};
